import React from "react";
import { useParams } from "react-router-dom";

import SubmissionsHeader from "./SubmissionsHeader";
import SubmissionsPending from "./SubmissionsPending";
import SubmissionsDenied from "./SubmissionsDenied";

const Submissions = () => {
    const { pageContent, username } = useParams();

    let content = null;

    if (pageContent === "photos-pending") {
        content = <SubmissionsPending />;
    }

    if (pageContent === "photos-denied") {
        content = <SubmissionsDenied />;
    }

    return (
        <>
            <SubmissionsHeader username={username} />
            {content}
        </>
    );
};

export default Submissions;
